define('hijack-click',[], function() {
    'use strict';

    /**
     * Redispatch given 'click' event.
     *
     * Copy all relevant event data but nullify
     * defaultPrevented allowing to redispatch the
     * original event as it was before calling
     * .preventDefault().
     *
     * @param  {MouseEvent} originalEvent Original 'click' event
     */
    function redispatchClickEvent(originalEvent) {
        var eventClone = new MouseEvent('click', originalEvent);
        originalEvent.target.dispatchEvent(eventClone);
    }

    /**
     * Hijack a 'click' event on an element until given callback finishes
     * and redispatch it afterwards.
     *
     * @param  {HTMLElement}   el  Element on which to hijack 'click' events
     * @param  {Function} callback Callback to call upon click. The callback
     *                             should call its argument when done.
     * @param  {Number}   timeout  Max time to wait (in ms). Event will be
     *                             redispatched when timeout reached.
     * @return {Function}          Undo function. Call to deactivate hijacking.
     */
    function hijackClick(el, callback, timeout) {
        var hijacked = false;
        var timeoutId;

        function clickHandler(event) {
            if (!hijacked) {
                hijacked = true;

                event.preventDefault();
                event.stopImmediatePropagation();

                timeoutId = setTimeout(function timedOut() {
                    redispatchClickEvent(event);
                }, timeout);

                callback(function done() {
                    clearTimeout(timeoutId);
                    redispatchClickEvent(event);
                });
            }
        }

        el.addEventListener('click', clickHandler, true);

        return function undoHijack() {
            el.removeEventListener('click', clickHandler, true);
        };
    }

    return hijackClick;
});

